module.exports = __webpack_public_path__ + "media/images/btn_save_add_preg_test-2da826af3dd54aa34a76ab63e49d908f.gif";